// extracted by mini-css-extract-plugin
module.exports = {"password":"ChangePassword_password__3rM6E"};